import React, { useState } from "react";
import { FormFieldSet } from "../../components";
import AdminDashboard from "./AtsDashboard/AdminDashboard";
import OtherUsersDashboard from "./AtsDashboard/OtherUsersDashboard";
import { useSelector } from "react-redux";
import { getEndOfDay, getStartOfDay } from "../../utils/common";
import { formatWords2 } from "../../utils/stringUtils";

const AtsDashboard = () => {
  const { user } = useSelector((state) => state.auth);

  const [finalDataDuration, setFinalDataDuration] = useState({
    // from: new Date(),
    from: null,
    to: null,
  });

  return (
    <div className="flex-1 w-full flex flex-col gap-2 overflow-auto">
      <div className="flex justify-between items-center">
        <div>
          Hi {formatWords2(user?.data?.firstName) + " " + formatWords2(user?.data?.lastName)} Welcome back!
        </div>
        <div>
          <FormFieldSet
            title="Date Range"
            noTitle
            name="dateRange"
            type="datepickerRange"
            value={finalDataDuration}
            defaultOption="this week"
            onChange={(value) => {
              if (value?.from && value?.to) {
                setFinalDataDuration(value || { from: null, to: null });
              }
            }}
          />
        </div>
      </div>

      {/* {user?.data?.role?.name?.toLowerCase() === "admin" ? ( */}
      {user?.data?.role?.type === 1 ? (
        <AdminDashboard
          finalDataDuration={{
            from: finalDataDuration.from
              ? getStartOfDay(finalDataDuration.from)
              : "",
            to: finalDataDuration.to ? getEndOfDay(finalDataDuration.to) : "",
          }}
        />
      ) : (
        <OtherUsersDashboard
          finalDataDuration={{
            from: finalDataDuration.from
              ? getStartOfDay(finalDataDuration.from)
              : "",
            to: finalDataDuration.to ? getEndOfDay(finalDataDuration.to) : "",
          }}
          roleType={user?.data?.role?.type}
        />
      )}
    </div>
  );
};

export default AtsDashboard;
